var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-navigation-entry__icon-bullet",on:{"click":_vm.onClick}},[_c('div',{style:({ backgroundColor: _vm.formattedColor })})])
}
var staticRenderFns = []

export { render, staticRenderFns }